import * as React from "react";

import { TranslatedMessage } from "~i18n/translate";

// markup only. No props, no tests
export default function LiveblogDecoration() {
    return (
        <span
            className="text-red-refresh2024-500"
            data-component="liveblog-decoration"
        >
            <TranslatedMessage id="liveLiveBlog" defaultMessage="Live:" />{" "}
        </span>
    );
}
